import { useState, useEffect } from "react";
import { List } from 'antd-mobile'
import { getWorkService } from 'api/api'

const WorkService = () => {
  // 初始化调用接口
  const [data, setData] = useState([]);
  useEffect(() => {
    getWorkService().then((res) => {
      setData(res.data);
    });
  }, []);

  /**点击跳转 */
  const handleClick = (item) => {
    const { url } = item;
    if (url) {
      window.location.href = item.url
    }
  }


  return (
    <div className="workService">
      <List
      // header='办事服务'
      >
        {data.length > 0
          ?
          data.map((item, index) => {
            return (
              <List.Item
                key={index}
                // arrow="horizontal"
                onClick={() => { handleClick(item) }}
              >
                {item.name}
              </List.Item>
            )
          })
          :
          <List.Item>暂无数据</List.Item>
        }
      </List>
    </div>
  );
};

export { WorkService }